import { useQuery } from 'react-query';

import { banksApi, currencyApi } from 'api';
import { QueryKey } from 'enums';
import { Bank, Currency } from 'types';

type UseStaticDataInput = {
  enabled: boolean;
};

export type UseStaticDataResult = {
  banks: Bank[] | undefined;
  currencies: Currency[] | undefined;
  isBanksLoading: boolean;
  isCurrenciesLoading: boolean;
  isBanksSuccess: boolean;
  isCurrenciesSuccess: boolean;
};

export const useStaticData = ({
  enabled,
}: UseStaticDataInput): UseStaticDataResult => {
  const {
    isLoading: isBanksLoading,
    isSuccess: isBanksSuccess,
    data: banks,
  } = useQuery(QueryKey.Banks, banksApi.getAll, {
    enabled,
    staleTime: Infinity,
  });

  const {
    isLoading: isCurrenciesLoading,
    isSuccess: isCurrenciesSuccess,
    data: currencies,
  } = useQuery(QueryKey.Currencies, currencyApi.getFiat, {
    enabled,
    staleTime: Infinity,
  });

  return {
    banks,
    currencies,
    isBanksLoading,
    isCurrenciesLoading,
    isBanksSuccess,
    isCurrenciesSuccess,
  };
};
